import { useEffect, useCallback, useState } from "react";
import { useFormikContext } from "formik";

import { debounce } from "lodash";

export type Props = {
  debounceMs?: number,
  children?: (savedAt?: Date) => JSX.Element
}

const SaveOnChange = ({ debounceMs = 250, children }: Props) => {
  const { initialValues, values, submitForm } = useFormikContext();
  const [lastSaved, setLastSaved] = useState<Date>();

  const debouncedSubmit = useCallback(
    debounce(
      () => submitForm().then(() => setLastSaved(new Date())),
      debounceMs,
    ),
    [debounceMs, submitForm],
  );

  useEffect(() => {
    if (values === initialValues) return;

    debouncedSubmit();
  }, [debouncedSubmit, initialValues, values]);

  if (children) return children(lastSaved);

  return null;
};

export default SaveOnChange;
